import Button from "../../../components/button/Button";
import "./image.css";

export default function Image({ item, onClicked }) {
  const handleLink = () => {
    onClicked && onClicked();
    window.open(item.live, "_blank");
  };
  return (
    <div className="w-full h-full relative">
      <img src={item.image} alt="images" />
      <div className="fixed top-52 right-0">
        <div onClick={onClicked && onClicked} className="w-24 h-10 bg-secondary-300 text-primary-800">
          <Button title="Back" />
        </div>

        <div onClick={handleLink} className="mt-5 w-24 h-10 bg-primary-700 text-secondary-500">
          <Button title="Live On" />
        </div>
      </div>
    </div>
  );
}
